import { render, staticRenderFns } from "./ProjectChooseActionsReadOnlyView.vue?vue&type=template&id=41cecbc8&scoped=true&"
import script from "./ProjectChooseActionsReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseActionsReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChooseActionsReadOnlyView.vue?vue&type=style&index=0&id=41cecbc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cecbc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VCard,VLayout,VToolbar})
